<template>
  <div class="page workorder">
      <div class="row printsummary">
        <div class="col-5">
          <div class="row">
            <div class="col-12">
              <label>{{$t('PATIENTNAME')}}</label>
              <div class="summaryval">{{patientdata.name}} {{patientdata.surname}}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <label class="sec">{{$t('NOTICE')}}</label>
              <div class="summaryval sec">{{workorder.notice}}</div>
            </div>
          </div>
        </div>
        <div class="col-5">
          <div class="row">
            <div class="col-12">
              <label>{{$t('DOCTOR')}}</label>
              <div class="summaryval">{{getDoctor()}}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <label>{{$t('TECHNICIAN')}}</label>
              <div class="summaryval">{{getTechnician()}}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <label>{{$t('OPENDATE')}}</label>
              <div class="summaryval">{{workorder.openDateTime}}</div>
            </div>
          </div>
          <div v-if="workorder.color" class="row">
            <div class="col-12">
              <label>{{$t('COLOR')}}</label>
              <div class="summaryval">{{workorder.color}}</div>
            </div>
          </div>
        </div>
        <div class="col-2">
          <img src="../assets/img/wd-logo.svg" alt="" />
        </div>
      </div>
      <div class="row">
        <div class="col-12 center mainworkorderteeth">
          <img class="workorderteethimg" src="../assets/img/teeth.svg">
          <div class="workorderteeth">
            <div class="selectedteeth"><teeth v-bind:tooth="tooth" v-bind:separators="separators"></teeth></div>
            <span class="bigname-type" v-for="props in toothprops.upper" v-bind:style="'background-color: '+props.color">{{props.name}}</span>
            <div class="upper">
              <div class="left">
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[18]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[17]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[16]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth smaller"><span class="shortname-type" v-for="props in toothprops[15]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth smaller"><span class="shortname-type" v-for="props in toothprops[14]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth small"><span class="shortname-type" v-for="props in toothprops[13]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[12]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[11]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
              </div>
              <div class="right">
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[21]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[22]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth small"><span class="shortname-type" v-for="props in toothprops[23]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth smaller"><span class="shortname-type" v-for="props in toothprops[24]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth smaller"><span class="shortname-type" v-for="props in toothprops[25]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[26]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[27]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[28]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
              </div>
            </div>
            <div class="middle"></div>
            <div class="lower">
              <div class="left">
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[48]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[47]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[46]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth smaller"><span class="shortname-type" v-for="props in toothprops[45]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth smaller"><span class="shortname-type" v-for="props in toothprops[44]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth small"><span class="shortname-type" v-for="props in toothprops[43]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth smallest"><span class="shortname-type" v-for="props in toothprops[42]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth smallest"><span class="shortname-type" v-for="props in toothprops[41]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
              </div>
              <div class="right">
                <div class="tooth smallest"><span class="shortname-type" v-for="props in toothprops[31]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth smallest"><span class="shortname-type" v-for="props in toothprops[32]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth small"><span class="shortname-type" v-for="props in toothprops[33]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth smaller"><span class="shortname-type" v-for="props in toothprops[34]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth smaller"><span class="shortname-type" v-for="props in toothprops[35]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[36]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[37]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                <div class="tooth"><span class="shortname-type" v-for="props in toothprops[38]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
              </div>
            </div>
            <span class="bigname-type lower-type" v-for="props in toothprops.lower" v-bind:style="'background-color: '+props.color">{{props.name}}</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import Teeth from '@/components/Teeth.vue'
import usersApi from '@/api/users'
import patientsApi from '@/api/patients'
import workordersApi from '@/api/workorders'
import workorderstalksApi from '@/api/workordertalks'
import proteticsApi from '@/api/protetics'
import proteticColorsApi from '@/api/protetic_colors'
var moment  = require('moment');

export default {
  name: 'PrintWorkOrder',
  components:
  {
    'teeth': Teeth
  },
  data: function()
  {
    return {
      workOrderId: false,
      patientdata: {},
      workorder: {},
      toothprops: {},
      tooth:
      {
        18: false,
        17: false,
        16: false,
        15: false,
        14: false,
        13: false,
        12: false,
        11: false,

        28: false,
        27: false,
        26: false,
        25: false,
        24: false,
        23: false,
        22: false,
        21: false,

        48: false,
        47: false,
        46: false,
        45: false,
        44: false,
        43: false,
        42: false,
        41: false,

        38: false,
        37: false,
        36: false,
        35: false,
        34: false,
        33: false,
        32: false,
        31: false,
        upper: false,
        lower: false
      },
      separators:
      {
        18: false,
        17: false,
        16: false,
        15: false,
        14: false,
        13: false,
        12: false,
        11: false,

        28: false,
        27: false,
        26: false,
        25: false,
        24: false,
        23: false,
        22: false,
        21: false,

        48: false,
        47: false,
        46: false,
        45: false,
        44: false,
        43: false,
        42: false,
        41: false,

        38: false,
        37: false,
        36: false,
        35: false,
        34: false,
        33: false,
        32: false,
        31: false
      },
      upperSelected: false,
      lowerSelected: false,
      showProtetics: false,
      showInfo: false
    };
  },
  created: function()
  {
    var me = this;

    me.workOrderId = me.$route.params.workOrderId;

    me.refreshProtetics();
    me.getWorkOrder();
  },
  methods:
  {
    getDoctor()
    {
      var me = this;

      if(me.workorder.doctorName == null)
      {
        return me.workorder.dummyPartner;
      }

      return me.workorder.doctorName+' '+me.workorder.doctorSurname;
    },
    getTechnician()
    {
      var me = this;

      if(me.workorder.tehnicianName == null)
      {
        return me.workorder.dummyPartner;
      }

      return me.workorder.tehnicianName+' '+me.workorder.technicianSurname;
    },
    getWorkOrder()
    {
      var me = this;

      workordersApi.getWorkOrders({workOrderId: me.workOrderId}, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }

        me.workorder = data.root[0];
        if(data.root[0].separators != '') me.separators = JSON.parse(data.root[0].separators);

        patientsApi.getPatient({id: me.workorder.patientId}, function(data)
        {
          if(data.error && data.error == true)
          {
            Vue.$notify.error(data.notice);
            return;
          }
          me.patientdata = data.root;
        });

        me.getProtetics();
      });
    },
    getProtetics: function()
    {
      var me = this;
      proteticsApi.getProtetics({workOrderId: me.workOrderId, active: 1}, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }
        me.protetics = data;
      });
    },
    refreshProtetics: function()
    {
      var me = this;
      workordersApi.getProtetics({workOrderId: me.workOrderId}, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }

        me.toothprops = data.data;
      });
    }
  },
  watch:
  {

  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PrintWorkOrder.vue